export const RefreshAllResource = "RefreshAllResources";
export const RefreshMyResource = "RefreshMyResources";
export const RefreshSystemUsers = "RefreshSystemUsers";
export const RefreshDatabasePolicy = "RefreshDatabasePolicy";
export const RefreshPasswordPolicy = "RefreshPasswordPolicy";
export const RefreshPasswordRotatePolicy = "RefreshPasswordRotatePolicy";
export const RefreshSSO = "RefreshSSO";
export const RefreshLDAP = "RefreshLDAP";
export const RefreshLocalAccounts = "RefreshLocalAccounts";
export const RefreshNetworkScan = "RefreshNetworkScan";
export const RefreshAuthentication = "RefreshAuthentication";
export const RefreshTwoFA = "RefreshTwoFA";
export const RefreshSMTP = "RefreshSMTP";
export const RefreshBranding = "RefreshBranding";
export const RefreshUserList = "RefreshUserList";
export const RefreshRoles = "RefreshRoles";
export const RefreshGroups = "RefreshGroups";
export const RefreshTickets = "RefreshTickets";
export const RefreshScopedAPIKeys = "RefreshScopedAPIKeys";
export const RefreshProductSettings = "RefreshProductSettings";
export const RefreshTicketingSettings = "RefreshTicketingSettings";
export const RefreshLiscense = "RefreshLiscense";
export const RefreshValutConfig = "RefreshValutConfig";
export const RefreshStorageConfig = "RefreshStorageConfig";
export const RefreshAuditDashboard = "RefreshAuditDashboard";
export const RefreshReport = "RefreshReport";
export const RefreshRealTime = "RefreshRealTime";
export const RefreshRecordSession = "RefreshRecordSession";
export const RefreshDashboard = "RefreshDashboard";
export const RefreshMyResources = "RefreshMyResources";
export const RefreshSetupTwoFA = "RefreshSetupTwoFA";
export const RefreshRDPPolicy = "RefreshRemoteRDP";
export const RefreshSSHPolicy = "RefreshSSHPolicy";
export const RefreshWebAppsPolicy = "RefreshWebAppsPolicy";
export const RefreshCustomEmail = "RefreshCustomEmail";
export const RefreshSIEM = "RefreshSIEM";
export const RefreshClientCredentials = "RefreshClientCredentials";
export const RefreshHealthService = "RefreshHealthService";
export const RefreshThreatDetection = "RefreshThreatDetection";
export const RefreshCertificateManager = "RefreshCertificateManager";
export const RefreshScheduleReport = "RefreshScheduleReport";
export const RefreshEPMCUSTOMPolicy = "RefreshEPMCUSTOMPolicy";
export const RefreshEPMDEFAULTPolicy = "RefreshEPMDEFAULTPolicy";
export const RefreshEPMAPPLICATIONGROUP = "RefreshEPMAPPLICATIONGROUP";
export const RefreshEPMAPPLICATIONDEFINITION = "RefreshEPMAPPLICATIONDEFINITION";
export const RefreshEPMDEVICES = "RefreshEPMDEVICES";
export const RefreshEPMDOWNLOADAGENT = "RefreshEPMDOWNLOADAGENT";
export const RefreshEPMAudits = "RefreshEPMAudits";
export const RefreshCloudDiscovery = "RefreshCloudDiscovery"
export const CloseSidebarAccordions = "CloseSidebarAccordions";
export const RefreshCustomProfileFieldsList = "RefreshCustomProfileFieldsList";
